import {
  FormControl,
  IconButton,
  Menu,
  TableCell,
  TableRow,
  Tooltip,
  tooltipClasses,
} from "@mui/material";

import {
  capitalizeFirstLetter,
  formatDate,
  formatDateWithTime,
  teamID,
  TYPE,
} from "../../../../utils/Utils";
import { CustomerStyle } from "../Customers.styles";
import { useAuth } from "../../../../context/Auth.context";
import ApiResponseDialog from "../dialog/dialogBody/ApiResponse.dialog";
import { Block, InsertDriveFileOutlined } from "@mui/icons-material";
import HocPopup from "../../../../hoc/hocPopup";
import { useMutation, useQuery, useSubscription } from "@apollo/client";
import {
  CONSENT_CONNECT,
  FETCH_INSURANCE_TRIGGER,
  REQUEST_QUOTE,
  TRANSACTION_HISTORY,
} from "../../../../graphql/mutation/mutation";
import { useAppContext } from "../../../../context/App.context";
import { useVerification } from "../../../../context/Verification.context";
import React, { useEffect, useState } from "react";
import Theme from "../../../../utils/Theme";
import CustomerDetailsPopup from "./CustomerDetailsPopup";
import DocumentsDialog from "../dialog/dialogBody/DocumentsPrint.dialog";
import RepullUsers from "../../../base/RepullUsers.component";
import InformationDialog from "../../../base/dialog-body/Information.dialog";
import { ON_INSURANCE_WEBHOOK } from "../../../../graphql/subscription/subscription";
import { PULL_INSURANCE } from "../../../../graphql/query/query";
import moment from "moment";
import { IoFlagSharp } from "react-icons/io5";
import { RiSendPlaneFill } from "react-icons/ri";
import { AiOutlineRedo } from "react-icons/ai";
import AccessDenied from "../../../base/dialog-body/AccessDenied";
import KnowledgeHubComponent from "../../../base/dialog-body/KnowledgeHub.component";
import { PiFlagPennantFill } from "react-icons/pi";

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const filterData = {
  customerName: "",
  dealershipName: "",
  date: moment(
    new Date().toLocaleString("en-US", {
      timeZone: userTimezone,
    })
  ).format("YYYY-MM-DD"),
  timestamp: new Date().getTimezoneOffset(),
};

const CustomerCartComponent = ({
  customer,
  hideEmployee,
  dialog,
  checkService,
  walkthrough,
}) => {
  const auth = useAuth();
  const app = useAppContext();

  const verification = useVerification();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isCalled, setCalled] = useState(false);
  const [status, setStatus] = useState(null);

  const [verificationData, setVerificationData] = useState({
    repull: false,
    transactionId: "",
    pullInsurance: {
      pullId: "",
      pullJwt: "",
    },
  });
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const vehicleId = customer.vehicles.filter(
  //   (vehicle) => vehicle.vehicle_status_id === 1
  // );

  const { data: onInsurancePull } = useSubscription(ON_INSURANCE_WEBHOOK, {
    variables: {
      pull_id: verificationData?.pullInsurance?.pullId,
    },
    skip: !verificationData?.pullInsurance?.pullId,
  });
  // const [requestQuote] = useMutation(REQUEST_QUOTE);
  const [fetchTrigger] = useMutation(FETCH_INSURANCE_TRIGGER, {
    onCompleted: async (data) => {
      console.log("fetchInsuranceTrigger:", data);
      if (data) {
        if (data.fetchInsuranceTrigger.errors) {
          dialog({
            open: true,
            bodyType: TYPE.DEFAULT,
            title: "Error",
            body: (
              <InformationDialog text={"UNAUTHORISED! Token is not matching"} />
            ),
          });
        } else {
          setStatus(null);
          setCalled(false);
        }
      }
    },
  });

  const [fetchTransactions, { loading: updateLoading }] =
    useMutation(TRANSACTION_HISTORY);

  useEffect(() => {
    if (onInsurancePull?.onPullInsurance) {
      setStatus(onInsurancePull.onPullInsurance.status);
      verification.setStatus(onInsurancePull.onPullInsurance.status);
    }
  }, [onInsurancePull]);

  const { loading: pullLoading } = useQuery(PULL_INSURANCE, {
    fetchPolicy: "network-only",
    skip: status !== "SUCCESS" || isCalled,
    variables: {
      pullInput: {
        dealership_id: parseInt(auth?.user.dealership_id),
        employee_user_id: parseInt(auth?.user?.user_id),
        teamId: "71c9a296-3c62-4438-82bb-5c57ff6a435d",
        pullId: verificationData?.pullInsurance?.pullId,
        pullJWT: verificationData?.pullInsurance?.pullJwt,
        // vehicle_id: verificationData?.customer?.vehicleId,
        customer: {
          user_id: parseInt(customer.customer.user_id),
          first_name: customer.customer?.first_name,
          last_name: customer.customer?.last_name,
          email: customer.contact?.email,
          mobile_number: customer.contact?.mobile_number?.replace(/\D/g, ""),
          // vin: vehicleId[0]?.vin,
        },
        isRepull: true,
      },
    },
    onCompleted: (data) => {
      verification.setStatus(null);
      setVerificationData(() => ({
        transactionId: "",
        pullInsurance: {
          pullId: "",
          pullJwt: "",
        },
      }));
      setCalled(true);
      if (data && data.pullInsurance.errors) {
        if (data.pullInsurance.errors[0].message) {
          dialog({
            open: true,
            bodyType: TYPE.DEFAULT,
            title: "Error",
            body: (
              <InformationDialog text={data.pullInsurance.errors[0].message} />
            ),
          });
        }
      } else {
        // setSuccess(true);
        // requestQuote({
        //   variables: {
        //     requestInput: {
        //       employee_user_id: parseInt(auth?.user?.user_id),
        //       user_id: customer.customer.user_id,
        //       dealership_id: parseInt(auth?.user?.dealership_id),
        //       d_startDate: app.fetchData.d_startDate,
        //       d_endDate: app.fetchData.d_endDate,
        //       f_startDate: app.fetchData.f_startDate,
        //       f_endDate: app.fetchData.f_endDate,
        //       pageCount: app.fetchData.pageCount,
        //       rowsPerPage: app.fetchData.rowsPerPage,
        //       search_employee: app.fetchData.searchEmployee,
        //       search_customer: app.fetchData.searchCustomer,
        //       isEmployeeOnly: false,
        //       timezone: new Date().getTimezoneOffset(),
        //       isRequestQuote: false,
        //       insuranceCompleted: true,
        //       insurance_id: data?.pullInsurance?.insurance_id,
        //     },
        //   },
        // });
        fetchTransactions({
          variables: {
            transactionInput: {
              date: filterData.date,
              search_customer: filterData.customerName,
              search_dealership: filterData.dealershipName,
              timestamp: filterData.timestamp,
              pageCount: app.fetchData.pageCount,
              rowsPerPage: 5,
              timezone: userTimezone,
            },
          },
        });
        fetchTrigger({
          variables: {
            requestInput: {
              employee_user_id: parseInt(auth.user.user_id),
              user_id: customer.customer.user_id,
              dealership_id: parseInt(auth?.user?.dealership_id),
              d_startDate: app.fetchData.d_startDate,
              d_endDate: app.fetchData.d_endDate,
              f_startDate: app.fetchData.f_startDate,
              f_endDate: app.fetchData.f_endDate,
              pageCount: app.fetchData.pageCount,
              rowsPerPage: app.fetchData.rowsPerPage,
              search_employee: app.fetchData.searchEmployee,
              search_customer: app.fetchData.searchCustomer,
              isEmployeeOnly: false,
              timezone: new Date().getTimezoneOffset(),
            },
          },
        });
      }
    },
  });

  const [request, { loading: consentLoading }] = useMutation(CONSENT_CONNECT, {
    onError: (err) => {
      console.log(err);
    },
    onCompleted: async (data) => {
      console.log("consoleData:", data);
      if (data) {
        if (data.consentAndConnect.errors) {
          dialog({
            open: true,
            bodyType: TYPE.DEFAULT,
            title: "Error",
            body: (
              <InformationDialog text={"UNAUTHORISED! Token is not matching"} />
            ),
          });
        } else if (data.consentAndConnect.pull_id) {
          setVerificationData((prev) => ({
            ...prev,
            pullInsurance: {
              pullId: data.consentAndConnect.pull_id,
              pullJwt: data.consentAndConnect.pull_jwt,
            },
          }));
        } else {
          console.log("error", data);
        }
      }
    },
  });

  const continueHandler = async () => {
    if (
      customer.customer?.insurance_carrier &&
      customer?.insuranceList?.length > 0 &&
      customer.insuranceList[0]?.policy?.total_premium
    ) {
      const datas = customer.customer;
      const transactionId = Date.now().toString();
      setVerificationData((prev) => ({
        ...prev,
        transactionId: transactionId,
      }));
      request({
        variables: {
          insuranceInput: {
            employee_user_id: parseInt(auth?.user?.user_id),
            device_identifier: "davi",
            terms_version: 1,
            consent_language:
              "By clicking <name of button> you agree to the Canopy Connect End User Privacy Policy and Terms of Service",
            public_alias: teamID,
            insurer_name: datas.insurance_carrier,
            insurer_username: datas.carrier_userid,
            insurer_password: datas.carrier_password,
            insurer_thirdField: datas.third_field,
            transaction_id: transactionId,
            customer: {
              user_id: parseInt(customer.customer.user_id),
              first_name: datas?.first_name,
              last_name: datas?.last_name,
              email: customer.contact?.email,
              mobile_number: customer.contact?.mobile_number,
              // vin: vehicleId[0]?.vin || "",
            },
            dealership_id: parseInt(auth?.user.dealership_id),
          },
        },
      });
    } else {
      window.open(
        `/verification/consent/${auth?.user?.user_id}/${
          auth?.user?.dealership_id
        }/${customer.customer.user_id}/${walkthrough}/${
          app.fetchData.pageCount || 0
        }/false?service=1&fct=true`,
        "_blank"
      );
    }
  };

  const policyEnd = customer.insuranceList[0]?.policy.policy_end;

  const isExpired = policyEnd ? new Date(policyEnd) < new Date() : false;

  const getTooltipPopperStyles = (px) => ({
    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
      {
        marginTop: px,
      },
    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
      {
        marginBottom: px,
      },
    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
      {
        marginLeft: px,
      },
    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
      {
        marginRight: px,
      },
  });

  return (
    <>
      <TableRow key={customer.customer.user_id} sx={CustomerStyle.customerUser}>
        <TableCell sx={CustomerStyle.noBorder}>
          {customer.customer ? (
            <Tooltip
              title={formatDateWithTime(customer.customer.date).substring(10)}
              placement="top"
              enterDelay={1000}
              leaveDelay={0}
              enterNextDelay={1000}
              slotProps={{
                popper: {
                  sx: getTooltipPopperStyles("0px"),
                },
              }}
            >
              <span>{formatDate(customer.customer.date)}</span>
            </Tooltip>
          ) : (
            "N/A"
          )}
        </TableCell>

        {auth.user.loggedInAs === "manager" && !hideEmployee ? (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            <Tooltip
              title={
                capitalizeFirstLetter(customer.employee.employee_firstname) +
                " " +
                capitalizeFirstLetter(customer.employee.employee_lastname)
              }
              placement="top"
              enterDelay={1000}
              leaveDelay={0}
              enterNextDelay={1000}
              slotProps={{
                popper: {
                  sx: getTooltipPopperStyles("0px"),
                },
              }}
            >
              <p>
                {capitalizeFirstLetter(customer.employee.employee_lastname)}
              </p>
            </Tooltip>
          </TableCell>
        ) : null}
        {/* {auth.user.loggedInAs === "manager" ? ( */}
        <TableCell
          align="center"
          sx={{
            ...CustomerStyle.noBorder,
            color: Theme.palette.primary.main,
            cursor: "pointer",
          }}
          onClick={() => {
            {
              dialog({
                open: true,
                bodyType: TYPE.CUSTOMER_DETAILS,
                maxWidth: "md",
                body: <CustomerDetailsPopup customer={customer} />,
              });
            }
          }}
        >
          <Tooltip
            title={
              capitalizeFirstLetter(customer.customer.first_name) +
              " " +
              capitalizeFirstLetter(customer.customer.last_name)
            }
            placement="top"
            enterDelay={1000}
            leaveDelay={0}
            enterNextDelay={1000}
            slotProps={{
              popper: {
                sx: getTooltipPopperStyles("0px"),
              },
            }}
          >
            <p>{capitalizeFirstLetter(customer?.customer?.last_name)}</p>
          </Tooltip>
        </TableCell>

        <TableCell align="center" sx={CustomerStyle.noBorder}>
          <Tooltip
            title={
              customer.customer.mfa_preference
                ? "MFA-Repull"
                : customer.insuranceList?.[0]?.policy?.total_premium
                ? "Repull"
                : "verification"
            }
            placement="top"
            enterDelay={1000}
            leaveDelay={0}
            enterNextDelay={1000}
            slotProps={{
              popper: {
                sx: getTooltipPopperStyles("0px"),
              },
            }}
          >
            <IconButton
              onClick={() => {
                dialog({
                  open: true,
                  bodyType: TYPE.REPULL_DETAILS,
                  maxWidth: "md",
                  body: (
                    <RepullUsers
                      repull={
                        customer?.customer?.insurance_carrier ? true : false
                      }
                      customerId={customer.customer.user_id}
                      customers={customer}
                      isCalled={isCalled}
                      continueHandler={continueHandler}
                      loading={consentLoading || pullLoading || updateLoading}
                      onInsurancePull={onInsurancePull}
                      verificationData={verificationData}
                      walkthrough={walkthrough}
                      onClose={handleClose}
                    />
                  ),
                });
              }}
            >
              {customer?.insuranceList?.length > 0 &&
              customer.insuranceList[0]?.policy?.total_premium ? (
                <AiOutlineRedo size={20} color={Theme.palette.primary.main} />
              ) : (
                <RiSendPlaneFill size={20} color={Theme.palette.primary.main} />
              )}
            </IconButton>
          </Tooltip>
        </TableCell>

        {checkService?.knowledgeHub && (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            <Tooltip
              title={"Artifacts"}
              placement="top"
              enterDelay={1000}
              leaveDelay={0}
              enterNextDelay={1000}
              slotProps={{
                popper: {
                  sx: getTooltipPopperStyles("0px"),
                },
              }}
            >
              <IconButton
                onClick={() => {
                  dialog({
                    open: true,
                    bodyType: TYPE.KNOWLEDGE_HUB,
                    maxWidth: "md",
                    body: <KnowledgeHubComponent customer={customer} />,
                  });
                }}
              >
                {customer?.customer?.watched_artifacts ? (
                  <AiOutlineRedo size={20} color={Theme.palette.primary.main} />
                ) : (
                  <RiSendPlaneFill
                    size={20}
                    color={Theme.palette.primary.main}
                  />
                )}
              </IconButton>
            </Tooltip>
          </TableCell>
        )}
        {checkService?.idVerfication && (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            <IconButton
              onClick={() => {
                dialog({
                  open: true,
                  bodyType: TYPE.ACCESS_DENIED,
                  maxWidth: "sm",
                  body: <AccessDenied />,
                });
              }}
            >
              --
            </IconButton>
          </TableCell>
        )}
        {checkService?.prequal && (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            <IconButton
              onClick={() => {
                dialog({
                  open: true,
                  bodyType: TYPE.ACCESS_DENIED,
                  maxWidth: "sm",
                  body: <AccessDenied />,
                });
              }}
            >
              --
            </IconButton>
          </TableCell>
        )}

        <TableCell align="center" sx={CustomerStyle.artifactStyle}>
          {customer?.reviewResponse?.isReview ? "Y" : "N"}
        </TableCell>
        {customer?.reviewResponse?.answer ? (
          <TableCell align="center" sx={CustomerStyle.artifactStyle}>
            {capitalizeFirstLetter(customer?.reviewResponse?.answer)}
          </TableCell>
        ) : (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            N/A
          </TableCell>
        )}

        <TableCell align="center" sx={CustomerStyle.artifactStyle}>
          {customer.appointmentResponse?.date ? "Y" : "N"}
        </TableCell>
        <TableCell align="center" sx={CustomerStyle.artifactStyle}>
          {customer.referralResponse?.length > 0 ? "Y" : "N"}
        </TableCell>
        <TableCell align="center" sx={CustomerStyle.artifactStyle}>
          {customer.isAppsDownloaded ? "Y" : "N"}
        </TableCell>

        <TableCell
          sx={{
            ...CustomerStyle.noBorder,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "10ch",
          }}
          // align="center"
        >
          <Tooltip
            title={
              customer?.insuranceList?.length > 0
                ? customer.insuranceList[0]?.policy?.carrier_name?.toUpperCase()
                : "N/A"
            }
            placement="top-start"
            enterDelay={1000}
            leaveDelay={0}
            enterNextDelay={1000}
            slotProps={{
              popper: {
                sx: getTooltipPopperStyles("0px"),
              },
            }}
          >
            <span>
              {customer?.insuranceList?.length > 0
                ? customer.insuranceList[0]?.policy?.carrier_name?.toUpperCase()
                : "N/A"}
            </span>
          </Tooltip>
        </TableCell>
        {customer?.insuranceList?.length > 0 &&
        customer.insuranceList[0]?.policy?.policy_number ? (
          <TableCell
            align="center"
            sx={{
              ...CustomerStyle.noBorder,
              color: customer?.insuranceList[0]?.policy?.is_issue
                ? Theme.palette.error.main
                : Theme.palette.primary.main,
              fontWeight: customer?.insuranceList[0]?.policy?.is_issue
                ? "bold"
                : null,
              cursor: "pointer",
            }}
            onClick={() => {
              {
                dialog({
                  open: true,
                  bodyType: TYPE.API_LOG,
                  maxWidth: "lg",
                  body: (
                    <ApiResponseDialog userId={customer.customer.user_id} />
                  ),
                });
              }
            }}
          >
            {customer.insuranceList[0]?.policy.policy_number}
          </TableCell>
        ) : (
          <TableCell
            align="center"
            sx={CustomerStyle?.noBorder}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            N/A
          </TableCell>
        )}

        <TableCell align="center" sx={CustomerStyle.noBorder}>
          {customer.insuranceList?.length > 0 ? (
            <Tooltip
              title={
                <div>
                  <div>
                    {formatDate(customer.insuranceList[0]?.policy.policy_begin)}
                  </div>
                  <div>
                    {formatDate(customer.insuranceList[0]?.policy.policy_end)}
                  </div>
                </div>
              }
              placement="top"
              enterDelay={1000}
              leaveDelay={0}
              enterNextDelay={1000}
              slotProps={{
                popper: {
                  sx: getTooltipPopperStyles("5px"),
                },
              }}
            >
              <span>
                <PiFlagPennantFill
                  size={20}
                  color={
                    isExpired
                      ? Theme.palette.error.main
                      : Theme.palette.primary.main
                  }
                />
              </span>
            </Tooltip>
          ) : (
            "N/A"
          )}
        </TableCell>
        <TableCell align="center" sx={CustomerStyle.noBorder}>
          {customer.insuranceList?.length > 0 ? (
            <Tooltip
              title={
                <div>
                  <div>
                    Collision:{" "}
                    {customer.insuranceList[0]?.policy.collision_deductible !=
                    null
                      ? `$${customer.insuranceList[0].policy.collision_deductible}`
                      : "N/A"}
                  </div>
                  <div>
                    Comprehensive:{" "}
                    {customer.insuranceList[0]?.policy.comp_deductible != null
                      ? `$${customer.insuranceList[0].policy.comp_deductible}`
                      : "N/A"}
                  </div>
                </div>
              }
              placement="top"
              enterDelay={1000}
              leaveDelay={0}
              enterNextDelay={1000}
              slotProps={{
                popper: {
                  sx: getTooltipPopperStyles("5px"),
                },
              }}
            >
              <span>
                <PiFlagPennantFill
                  size={20}
                           color={
  customer.insuranceList[0].policy.collision_deductible > 500 ||
  customer.insuranceList[0]?.policy.comp_deductible > 500 ||
  customer.insuranceList[0]?.policy.collision_deductible == null ||
  customer.insuranceList[0]?.policy.comp_deductible == null
    ? Theme.palette.error.main
    : Theme.palette.primary.main
}
                />
              </span>
            </Tooltip>
          ) : (
            "N/A"
          )}
        </TableCell>

        {auth.user.loggedInAs === "manager" && (
          <TableCell align="center" sx={CustomerStyle.artifactStyle}>
            {customer.requestQuote?.customerStatusId === 0 ? "N" : "Y"}
          </TableCell>
        )}

        {customer?.insuranceList?.length > 0 &&
        customer.insuranceList[0]?.documents != null ? (
          <TableCell
            align="center"
            sx={{
              ...CustomerStyle.noBorder,
              color: "#00ab55",
              cursor: "pointer",
              paddingX: "8px",
              alignSelf: "center",
            }}
          >
            <FormControl>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{ overflow: "scroll" }}
              >
                <DocumentsDialog
                  customer={customer}
                  user={auth?.user}
                  userId={customer.customer.user_id}
                />
              </Menu>
            </FormControl>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              sx={CustomerStyle.insuranceCarrier}
              onClick={handleClick}
            >
              <InsertDriveFileOutlined
                color={
                  customer.insuranceList[0]?.policy?.is_issue
                    ? "error"
                    : Theme?.palette?.primary?.main
                }
              />
            </IconButton>
          </TableCell>
        ) : (
          <TableCell align="center" sx={CustomerStyle.noBorder}>
            <Block size={24} sx={{ color: "#b5b5b5" }} />
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

export default HocPopup(CustomerCartComponent);
